import { Component } from '@angular/core';

@Component({
  selector: 'subs-form-buttons',
  template: `
    <ng-content></ng-content>
  `,
})
export class ButtonAreaComponent {}
